import type { BrowserView, BrowserWindow } from 'electron';
import type { IGlobalTab } from './Tab';

export interface IWindow {
  window: BrowserWindow;
}

export interface IView {
  view: BrowserView;
  tabId?: number;
  globalTab?: IGlobalTab;
  navigateListener?: boolean;
}

export enum WindowType {
  MAIN = 'main',
  LOGIN = 'login',
}
